import { Button, Image } from "antd";
import React from "react";
import ItemTitle from "../../common/ItemTitle";
import {
  pointSVG,
  listSVG,
  arrowSVG,
  deleteSVG,
  editSVG,
  detailsSVG,
} from "../../../assets/catalog/SVGs";
import { useIntl } from "react-intl";
import imgPlaceHolder from "../../../assets/images/PLACE HOLDER - CARD 1.png";
const ProductsRowData = ({ data, deleteRowData, editRowData }: any) => {
  const intl = useIntl();
  return (
    <div className="flex flex-col items-center text-left w-full rounded-lg ">
      <div className="flex flex-col items-center justify-start w-full gap-4 py-4 bg-[#FBFBFF] px-5 mt-2 rounded-md">
        <span className="flex items-center justify-start gap-2 w-full text-base font-medium">
          {detailsSVG} {intl.formatMessage({ id: "product_details" })}
        </span>
        <div className="flex items-center justify-between w-full h-full">
          <div className="w-full h-full flex items-center gap-6 p-2">
            <Image
              width={200}
              height={100}
              src={data?.media}
              fallback={imgPlaceHolder}
            />
            <div className=" w-full space-y-2 h-full">
              <div className="flex items-center justify-between gap-4 w-full  ">
                <div className="flex items-center gap-4 w-full h-full font-medium">
                  <ItemTitle
                    title={intl.formatMessage({ id: "brand" })}
                    subTitle={data?.brand?.name}
                  />
                  <ItemTitle
                    title={intl.formatMessage({ id: "supplier" })}
                    subTitle={data?.supplier?.name}
                  />
                </div>
                <div className="flex items-center gap-2 ">
                  <Button
                    onClick={() => editRowData()}
                    type="primary"
                    className="btn-primary-edit  min-w-[200px]"
                  >
                    {editSVG} {intl.formatMessage({ id: "edit_product" })}
                  </Button>
                  <Button
                    type="primary"
                    className="btn-primary-danger min-w-[200px]"
                    onClick={() => deleteRowData()}
                  >
                    {deleteSVG} {intl.formatMessage({ id: "delete_product" })}
                  </Button>
                </div>
              </div>
              <div className="flex items-center flex-wrap gap-4 w-full ">
                <span className="bg-[#EEF0FF] rounded-lg text-color-primary capitalize  px-4 py-2">
                  {intl.formatMessage({ id: "size" })} {data?.amount}{" "}
                  {data?.measure}
                </span>
                {data?.sku_code.map((e: any) => (
                  <span className="bg-white rounded-lg px-4 py-2 text-color-primary ">
                    SKU # {e}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-start text-right gap-4 w-full font-medium">
          <span className="min-w-[173px] flex items-center flex-nowrap whitespace-nowrap">
            {intl.formatMessage({ id: "pricing_product" })}
          </span>
          <div className="bg-white rounded-lg px-4 py-2 flex items-center justify-between">
            {listSVG}
            <ItemTitle
              title={intl.formatMessage({ id: "supply" })}
              subTitle={
                <div className="">
                  {`${data?.supply_price?.amount || data?.supply_price}`}
                  <span className="text-[12px] m-1 mt-8 font-medium ">
                    {intl.formatMessage({ id: "saudi_riyal" })}
                  </span>
                </div>
              }
            />
            {pointSVG}
            <ItemTitle
              title={intl.formatMessage({ id: "retail" })}
              subTitle={
                <div className="">
                  {`${data?.retail_price?.amount || data?.retail_price}`}
                  <span className="text-[12px] m-1 mt-8 font-medium ">
                    {intl.formatMessage({ id: "saudi_riyal" })}
                  </span>
                  <span className="text-[#479821] text-sm mx-2 ">
                    %{~~data?.markup}
                  </span>
                </div>
              }
            />
            {/* {pointSVG}
            <div className="px-4 py-1">{` `}</div> */}
            {/* <ItemTitle title="الضريبة المضافة " subTitle="2%" /> */}
          </div>
        </div>
      </div>
      <span
        onClick={() => editRowData()}
        className="text-color-primary flex items-end justify-end w-full gap-2 text-sm  mt-3 mx-1 cursor-pointer"
      >
        {arrowSVG}
        {intl.formatMessage({
          id: "see_more",
        })}
      </span>
    </div>
  );
};

export default ProductsRowData;
